import walidacjaVinu from '@components/form/validation/field/vin'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'VIN',
    name: 'vin'

}, walidacjaVinu)